import Environment from './Environment';
import Content from '../constants/Content';
import Logger from './Logger';

const getProductImageByColor = (media, color) => {
  try {
    if (!media || !media.length) {
      return 'https://s3.amazonaws.com/bitsy-product-images/default-product-image.png';
    }
    if (!color || color === 'NONE') return media[0].url;

    const colorIndex = media.map((mediaItem) => mediaItem.color).indexOf(color);

    if (colorIndex === -1) {
      return media[0].url;
    }

    return media[colorIndex].url;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getSubImage = (plan) => {
  try {
    let imageUrl = '';
    if (Environment.store.includes('bump')) {
      imageUrl =
        'https://s3.amazonaws.com/bitsy-product-images/subscription-plan-images/bump/';
    } else {
      imageUrl =
        'https://s3.amazonaws.com/bitsy-product-images/subscription-plan-images/bitsy/';
    }

    if (plan.title === 'Twelve Month') {
      imageUrl += '12-month.png';
    } else if (plan.title === 'Nine Month') {
      imageUrl += '9-month.png';
    } else if (plan.title === 'Six Month') {
      imageUrl += '6-month.png';
    } else if (plan.title === 'Three Month') {
      imageUrl += '3-month.png';
    } else {
      imageUrl += 'monthly.png';
    }

    return imageUrl;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getProductUrlForSubscription = (subscription) => {
  try {
    const { plan } = subscription;
    const planTitleforUrl = plan.title.split(' ').join('-').toLowerCase();
    if (plan.minimumMonths) {
      return `${Environment.getSelfDomain}/products/${planTitleforUrl}-pregnancy-subscription-box`;
    }
    return `${Environment.getSelfDomain}/products/bundled-${planTitleforUrl}`;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getDataForCart = (cart, includeViewedOn) => {
  try {
    const items = [];
    if (cart.subscription) {
      const { subscription } = cart;
      const imageUrl = getSubImage(subscription.plan);
      const productUrl = getProductUrlForSubscription(subscription);
      items.push({
        SKU: `${subscription.plan.title} ${Content.names.shortName} Subscription`,
        ProductName: `${subscription.plan.title} ${Content.names.shortName} Subscription`,
        Quantity: 1,
        ItemPrice:
          subscription.plan.costWithCoupon || subscription.plan.actualCost,
        RowTotal:
          subscription.plan.costWithCoupon || subscription.plan.actualCost,
        ProductURL: productUrl,
        ImageURL: imageUrl,
      });
    }
    if (cart.productsAndDetails) {
      cart.productsAndDetails.forEach((productsAndDetailsItem) => {
        const { product } = productsAndDetailsItem;
        const mediaUrl = getProductImageByColor(
          product.media,
          productsAndDetailsItem.color,
        );
        const viewedProductData = {
          SKU: product.sku || product.name,
          ProductName: product.name,
          Quantity: productsAndDetailsItem.quantity,
          ItemPrice:
            productsAndDetailsItem.promoItem && product.ownPromoData
              ? product.ownPromoData.cost
              : product.actualCost || 0,
          ProductURL: `${Environment.getSelfDomain}/products/${product.urlName}`,
          ImageURL: mediaUrl,
          Color:
            productsAndDetailsItem.color !== 'NONE'
              ? productsAndDetailsItem.color
              : '',
          Variation:
            productsAndDetailsItem.variation !== 'NONE'
              ? productsAndDetailsItem.variation
              : '',
          ID: product._id,
          isBreastPump: productsAndDetailsItem.isBreastPump,
        };

        if (includeViewedOn) {
          viewedProductData.ViewedOn = new Date();
        }
        items.push(viewedProductData);
      });
    }
    return items;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

// removes plus signs, dashes, parantheses, and spaces
const formatPhoneNumberOnlyNumbers = (number) => {
  if (!number) {
    return '';
  }
  return number
    .replace(/[+]/g, '')
    .replace(/-/g, '')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/\s/g, '');
};

const getCountryAndAreaCodeAndNumber = (number) => {
  if (!number) {
    return {
      countryCode: '',
      areaCode: '',
      phoneNumber: '',
    };
  }
  const formattedNumber = formatPhoneNumberOnlyNumbers(number);
  if (formattedNumber.length === 11) {
    return {
      countryCode: formattedNumber.substr(0, 1),
      areaCode: formattedNumber.substr(1, 3),
      phoneNumber: formattedNumber.substr(4, 7),
    };
  }
  return {
    countryCode: '1',
    areaCode: formattedNumber.substr(0, 3),
    phoneNumber: formattedNumber.substr(3, 7),
  };
};

export default {
  getProductImageByColor,
  getSubImage,
  getDataForCart,
  getCountryAndAreaCodeAndNumber,
};
